import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

import { Checkbox, Text, Radio, FormInputSwitch } from 'modules/common';

import * as c from './constants';

function SelectionItem({
  label,
  description,
  value,
  disabled,
  type,
  selectType,
  name,
  onSetFieldValue,
  onChange,
  isSwitchTrailing,
  id,
  isLoading,
  withSelector,
  withHiddenLabel,
  ...rest
}) {
  const style = {
    className: c.dispatchType?.[type],
  };
  const selectProps = {
    name,
    value,
    disabled,
    onSetFieldValue,
    onChange,
    isLoading,
    ...rest,
  };

  const dispatchSelector = {
    checkbox: <Checkbox {...selectProps} />,
    radio: <Radio {...selectProps} />,
    switch: <FormInputSwitch {...selectProps} />,
  };

  return (
    <div>
      {withHiddenLabel && <div className="ds-form-label opacity-0">RO</div>}

      <div
        className={cn('flex gap-ds-12', style.className, {
          'cursor-not-allowed': disabled,
          'items-center': selectType === 'switch',
          'flex-row-reverse justify-between': isSwitchTrailing,
        })}
        id={id}
      >
        {withSelector && <div>{dispatchSelector?.[selectType]}</div>}

        <div className="flex flex-col gap-ds-4">
          <Text color="primitive-black" weight="medium">
            {label}
          </Text>

          {description && (
            <Text type="caption" color="muted">
              {description}
            </Text>
          )}
        </div>
      </div>
    </div>
  );
}

SelectionItem.defaultProps = {
  value: false,
  disabled: false,
  isLoading: false,
  type: 'default',
  label: '',
  description: '',
  selectType: 'checkbox',
  onSetFieldValue: false,
  onChange: false,
  name: '',
  id: '',
  isSwitchTrailing: false,
  withHiddenLabel: false,
  withSelector: true,
};

SelectionItem.propTypes = {
  value: PropTypes.bool,
  withSelector: PropTypes.bool,
  withHiddenLabel: PropTypes.bool,
  isLoading: PropTypes.bool,
  label: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Object),
  ]),
  id: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  isSwitchTrailing: PropTypes.bool,
  type: PropTypes.oneOf(['default', 'card']),
  selectType: PropTypes.oneOf(['checkbox', 'radio', 'switch']),
  onChange: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(Object)]),
  onSetFieldValue: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.instanceOf(Object),
  ]),
};

export default SelectionItem;
